module.exports = __webpack_public_path__ + "media/images/flags/sx-5523d687fbf02a823ca629bdf067cb83.svg";